import queryString from 'query-string';
import { getCampaignType, campaignId } from 'utils/campaign';
import env from 'utils/env';
import { getCartVariants, flattenProducts } from '@nexus/fff-cart';
import request from './request';

export function requestCartData() {
  const type = getCampaignType();
  let requestUrl = `${env.aceApi}/1/carts/campaigns?type=${type}`;
  if (campaignId !== null) {
    requestUrl += `&campaignId=${campaignId}`;
  }
  return request(requestUrl);
}

export function getPublicCartData() {
  const campaignType = getCampaignType();
  const requestUrl = `${env.publicAceApi}/1/carts/campaigns?campaignType=${campaignType}`;
  return request(requestUrl);
}

export async function getCartData() {
  const { products: productsWithVariants, cartDetails } =
    await requestCartData();
  const { products, variants } = flattenProducts(productsWithVariants);
  return { products, variants, cartDetails };
}

export async function fetchCartData() {
  const {
    products: productsWithVariants,
    cartDetails,
    cartId,
  } = await requestCartData();
  const { products, variants } = flattenProducts(productsWithVariants);
  const cartVariants = getCartVariants(cartDetails, variants, products);
  return { cartDetails, cartVariants, cartId };
}

export function updateCart(variantId, queryParams) {
  const params = campaignId
    ? {
        ...queryParams,
        campaignId,
      }
    : queryParams;
  const requestUrl = `${env.aceApi}/1/carts/variants/${variantId}${
    params ? `?${queryString.stringify(params)}` : ''
  }`;
  return request(requestUrl, 'POST');
}

export function removeVariantItemsCart(variantId, queryParams) {
  const params = campaignId ? { ...queryParams, campaignId } : queryParams;
  const requestUrl = `${env.aceApi}/1/carts/variants/${variantId}${
    params ? `?${queryString.stringify(params)}` : ''
  }`;
  return request(requestUrl, 'DELETE', {}, {}, true, true, false);
}

export function getPurchasedVariants(campaignId, campaignType) {
  const requestUrl = `${env.aceApi}/1/carts/campaigns/${campaignId}/purchases?type=${campaignType}`;
  return request(requestUrl);
}

export function updatePublicCart(variantId, operation, cadenceType) {
  const queryParams = {
    campaignType: 'SHOP', // available only for shop page for now
    operation,
    ...(cadenceType && { cadenceType }),
  };
  const requestUrl = `${
    env.publicAceApi
  }/1/carts/variants/${variantId}?${queryString.stringify(queryParams)}`;
  return request(requestUrl, 'POST');
}
